import React from 'react';
import { RendererProps, WithClassname } from '@jsonforms/core';
import { twJoin } from 'tailwind-merge';
import { useJsonForms } from '@jsonforms/react';

type LayoutRendererProps = RendererProps & WithClassname & { dark?: boolean };

export const OtherGroupRenderer: React.FC<LayoutRendererProps> = ({ schema, dark }) => {
  const ctx = useJsonForms();
  const data = ctx.core?.data;

  if (!data?.mriOther) {
    return null;
  }
  const title = schema.properties?.mriOther?.title || 'Other';
  return (
    <div
      className={twJoin(
        '-mt-1 rounded-md border p-3',
        dark ? 'border-chineseBlack bg-arsenic text-white' : 'border-brightGray'
      )}
    >
      <div className="mb-0.5">{title}</div>
      <div className={'text-1624 font-semibold'}>{data.mriOtherText || 'N/A'}</div>
    </div>
  );
};
